// extracted by mini-css-extract-plugin
export default {"container":"SocialLinks_container__fkFJq","item":"SocialLinks_item__zuSSU"};